<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-job-position-job-group-policy-dialog-create
          v-if="$hasPermissionTo(['create job group policies'])"
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Job Group Policy's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in job group policy value here"
          append-icon="search"
          label="Search Job Group Policy"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>
  
    <!-- do not remove the border='' below -->
    <!-- css purpose -->
    <v-data-table
      :headers="headers"
      :items="filteredjobGroupPolicies"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.action="{ item }">
        <span v-if="statusFilter">
          <setup-job-position-job-group-policy-dialog-edit
            v-if="$hasPermissionTo(['update job group policies'])"
            :job-group-policy="item"
            @updated="loadData"
          />
          <span class="mx-1" />
          <setup-job-position-job-group-policy-dialog-delete
            v-if="$hasPermissionTo(['delete job group policies'])"
            :job-group-policy="item"
            @deleted="loadData"
          /> 
        </span>
        <span v-else>
          <setup-job-position-job-group-policy-dialog-restore
            v-if="$hasPermissionTo(['restore job group policies'])"
            :job-group-policy="item"
            @restored="loadData"
          />
        </span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupJobPositionJobGroupPolicyDialogCreate: () => import('@/components/hris/setup/job-position/job-group-policy/DialogCreate'),
      SetupJobPositionJobGroupPolicyDialogEdit: () => import('@/components/hris/setup/job-position/job-group-policy/DialogEdit'),
      SetupJobPositionJobGroupPolicyDialogDelete: () => import('@/components/hris/setup/job-position/job-group-policy/DialogDelete'),
      SetupJobPositionJobGroupPolicyDialogRestore: () => import('@/components/hris/setup/job-position/job-group-policy/DialogRestore'),
    },
    data () {
      return {
        jobGroupPolicies: [],
        trashedjobGroupPolicies: [],
        claims: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
      }
    },
    computed: {
      filteredjobGroupPolicies () {
        return this.statusFilter ? this.jobGroupPolicies : this.trashedjobGroupPolicies
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.jobGroupPolicies().list(),
          this.$api.jobGroupPolicies().listTrashed(),
        ]).then(([jobGroupPolicies, trashedjobGroupPolicies]) => {
          this.jobGroupPolicies = jobGroupPolicies.data
          this.trashedjobGroupPolicies = trashedjobGroupPolicies.data

          this.tableLoading = false
        })
      },
    },
  }
</script>
